import { useEffect, useState } from "react";
import { api, dt } from "@/lib/api";
import { Table, Tag, KV } from "@/components/common";
import { Modal } from "@/components/Modal";
import { useAuth } from "@/context/AuthContext";

const ST = { done: ["Selesai", "emerald"], missed: ["Terlewat", "rose"], pending: ["Menunggu", "amber"] };
const late = (m) => m == null ? "-" : m <= 0 ? "Tepat waktu" : m < 60 ? `${m} mnt` : m < 1440 ? `${Math.floor(m / 60)} jam ${m % 60} mnt` : `${Math.floor(m / 1440)} hari ${Math.floor((m % 1440) / 60)} jam`;

const History = ({ id }) => {
  const [h, setH] = useState(null);
  useEffect(() => { api.get(`/reminders/${id}/history`).then((r) => setH(r.data)); }, [id]);
  if (!h) return <div className="text-sm text-slate-500">Memuat riwayat…</div>;
  return (
    <div className="space-y-2" data-testid="reminder-history">
      <div className="flex gap-2 text-xs">{Object.entries(ST).map(([k, [l, t]]) => <Tag key={k} tone={t}><span data-testid={`history-stat-${k}`}>{l}: {h.stats[k]}</span></Tag>)}</div>
      <div className="border rounded-md max-h-80 overflow-y-auto">
        <Table testid="reminder-history-table" rows={h.rows} empty="Belum ada jadwal yang lewat" cols={[
          { h: "Jadwal", r: (r) => <span className="text-xs num">{dt(r.occurrence)}</span> },
          { h: "Penerima", r: (r) => <span className="text-xs font-medium">{r.user.name}</span> },
          { h: "Status", r: (r) => <Tag tone={ST[r.status][1]}>{ST[r.status][0]}</Tag> },
          { h: "Ditandai selesai", r: (r) => <span className="text-xs">{dt(r.done_at)}</span> },
          { h: "Keterlambatan", r: (r) => <span className={`text-xs ${r.late_minutes > 0 ? "text-rose-600 font-semibold" : ""}`}>{late(r.late_minutes)}</span> },
        ]} />
      </div>
    </div>
  );
};

export const ReminderDetail = ({ rm, onClose, onEdit }) => {
  const { can } = useAuth();
  return (
    <Modal open onOpenChange={onClose} title={`${rm.code} · ${rm.title}`} wide testid="reminder-detail-modal">
      <KV items={[["Jadwal", rm.schedule_text], ["Untuk", rm.targets.map((t) => t.name).join(", ")], ["Dibuat oleh", `${rm.created_by.name} · ${dt(rm.created_at)}`], ["Berikutnya", dt(rm.next_at)], ["Catatan", rm.note]]} />
      {rm.can_edit && <button onClick={onEdit} className="h-9 px-3 rounded-md border text-sm font-semibold bg-white hover:bg-slate-50 self-start" data-testid="reminder-edit-button">Ubah pengingat</button>}
      {can("reminder.history") && <History id={rm.id} />}
    </Modal>
  );
};
